// extracted by mini-css-extract-plugin
export default {"container":"forgot-password_container__tZhwN","form":"forgot-password_form__uji5r","actions":"forgot-password_actions__0S2I4","actions__link":"forgot-password_actions__link__+XA6T"};